import React from "react";
import CovenantsDesign from "../../components/AboutPageComponents/CovenantsDesign";
import OurVisionDesign from "../../components/AboutPageComponents/OurVisionDesign";
import StatsSection from "../../components/HomePageComponents/StatisticsSection";
import ExploreGallery from "../../components/AboutPageComponents/ExploreGallery";
import TestimonialsSection from "../../components/HomePageComponents/TestimonialSection";
import FAQSection from "../../components/HomePageComponents/FAQSection";
import OurTeam from "../../components/AboutPageComponents/OurTeam";
import LocationDetails from "../../components/AboutPageComponents/locationDetails";
import SimpleBanner from "../../components/common/Banner";
import OurMission from "../../components/AboutPageComponents/OurMission";

const About = () => {
  return (
    <div className="overflow-hidden">
      {/* <HeroSection /> */}
      <SimpleBanner name_primary="About" name_secondary="Us" />
      <div className="lg:px-12 px-2 mt-2 lg:mt-8">
        <CovenantsDesign />
        <OurMission />
        <OurVisionDesign />
      </div>
      <StatsSection />
      <div className="lg:px-12 px-8 mt-2 lg:mt-8">
        <ExploreGallery />
        <OurTeam />
      </div>
      <LocationDetails />
      <TestimonialsSection />
      <div className="lg:px-12 px-8 mt-2 lg:mt-8">
        <FAQSection />
      </div>
    </div>
  );
};

export default About;
